module.exports = __webpack_public_path__ + "static/media/gmc-go-drive.de77ee13.jpg";